window.addEventListener('load', () => {
  const element = document.querySelector('.pr-snippet-rating-decimal');
  if (!element) return; // Ensure the element exists

  const rating = parseFloat(element.textContent.trim());

  const elementToShow = document.getElementById('pr-reviewsnippet');
  const elementToHide = document.getElementById('pr-reviewdisplay');
  const replacementElement = document.getElementById('custom-pwr-write-review');

  if (!elementToShow) return;

  if (isNaN(rating) || rating === 0 || rating > 3.9) {
    elementToShow.style.display = 'block';
  } else {
    elementToHide.style.display = 'none';
    replacementElement.style.display = 'block';
  }
});
